import { TypeExternalPaymentMethod } from '@/lib/api/productCatalog/types';
import { EditPaymentMethodTranslations } from './EditPaymentMethodPage';
import interpolate from '@/utils/translations/interpolate';

export const getLocalizedPaymentLabel = (
  paymentMethod: TypeExternalPaymentMethod,
  t: EditPaymentMethodTranslations,
) => {
  if (!paymentMethod || !paymentMethod.localized_label) return '';
  const rawLabel = paymentMethod.localized_label;
  let localizedLabel;

  if (rawLabel.includes('Sepa')) {
    const bankCode = rawLabel.split(' ')[4];
    const cardLastFourDigits = rawLabel.split(' ').pop() || '';

    localizedLabel = interpolate(t.payment_method_sepa_label, {
      bankCode,
      cardLastFourDigits,
    });

    return localizedLabel;
  }

  if (rawLabel.includes('Babylist')) {
    localizedLabel = interpolate(t.payment_method_babylist_label);

    return localizedLabel;
  }

  if (
    rawLabel.includes('Subscription Credit Balance') ||
    rawLabel.includes('PayPal')
  ) {
    localizedLabel = rawLabel;
    return localizedLabel;
  }

  // For regular cards, extract the brand and last 4 digits and localize
  const endingIndex = rawLabel.toLowerCase().indexOf(' ending');
  const cardBrand =
    endingIndex !== -1
      ? rawLabel.slice(0, endingIndex)
      : rawLabel.split(' ')[0];
  const cardLastFourDigits = rawLabel.split(' ').pop() || '';

  localizedLabel = interpolate(t.payment_method_card_label, {
    cardBrand,
    cardLastFourDigits,
  });
  return localizedLabel;
};
